import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const IntegrationsIcon = forwardRef<SVGSVGElement, IconProps>(function IntegrationsIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.17981 8.81371C1.02627 8.12284 0.96 7.21334 0.96 6C0.96 4.78666 1.02627 3.87716 1.17981 3.18629C1.33093 2.50631 1.55352 2.09837 1.82595 1.82595C2.09837 1.55352 2.50631 1.33093 3.18629 1.17981C3.87716 1.02627 4.78666 0.96 6 0.96C7.21334 0.96 8.12284 1.02627 8.81371 1.17981C9.49369 1.33093 9.90163 1.55352 10.1741 1.82595C10.4465 2.09837 10.6691 2.50631 10.8202 3.18629C10.9737 3.87716 11.04 4.78666 11.04 6C11.04 7.21334 10.9737 8.12284 10.8202 8.81371C10.6691 9.49369 10.4465 9.90163 10.1741 10.1741C9.90163 10.4465 9.49369 10.6691 8.81371 10.8202C8.12284 10.9737 7.21334 11.04 6 11.04C4.78666 11.04 3.87716 10.9737 3.18629 10.8202C2.50631 10.6691 2.09837 10.4465 1.82595 10.1741C1.55352 9.90163 1.33093 9.49369 1.17981 8.81371ZM6 12C1.059 12 0 10.941 0 6C0 1.059 1.059 0 6 0C10.941 0 12 1.059 12 6C12 10.941 10.941 12 6 12Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M4.44255 5.32184C4.3304 5.32184 4.21825 5.26576 4.16218 5.20969L3.26498 4.25642C3.15283 4.20034 3.09676 4.03212 3.09676 3.91997V3.86389C3.09676 3.80782 3.15283 3.69567 3.20891 3.6396L4.1061 2.68632C4.27433 2.5181 4.5547 2.5181 4.72292 2.68632C4.89115 2.85455 4.89115 3.13492 4.72292 3.30315L4.49862 3.52745H7.69489C8.42386 3.52745 9.04068 4.14427 9.04068 4.87324V5.88259C9.04068 6.16297 8.87246 6.33119 8.59208 6.33119C8.31171 6.33119 8.14349 6.10689 8.14349 5.88259V4.87324C8.14349 4.59287 7.91919 4.36857 7.63881 4.36857H4.49862L4.72292 4.59287C4.89115 4.76109 4.89115 5.04146 4.72292 5.20969C4.66685 5.26576 4.5547 5.32184 4.44255 5.32184Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8.81633 8.34988L7.91913 9.24708C7.86306 9.30315 7.75091 9.35923 7.63876 9.35923C7.52661 9.35923 7.41446 9.30315 7.35838 9.24708C7.19016 9.07885 7.19016 8.79848 7.35838 8.63026L7.58268 8.40596H4.38642C3.65745 8.40596 3.04063 7.78913 3.04063 7.11624V6.10689C3.04063 5.88259 3.20885 5.65829 3.48922 5.65829C3.7696 5.65829 3.93782 5.82652 3.93782 6.10689V7.11624C3.93782 7.39661 4.16212 7.56484 4.44249 7.56484H7.58268L7.35838 7.34054C7.19016 7.17231 7.19016 6.89194 7.35838 6.72371C7.52661 6.55549 7.80698 6.55549 7.9752 6.72371L8.92848 7.67698C8.98455 7.73306 9.04063 7.78913 9.04063 7.90128V7.95736C8.92848 8.18166 8.8724 8.29381 8.81633 8.34988Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
